export const TIPS_MODULE = {
  MASTERS: 'MASTERS',
  MANAGE_ROLE: 'MANAGE_ROLE',
  MANAGE_USER: 'MANAGE_USER',
  MANAGE_SEGMENT: 'MANAGE_SEGMENT',
  CONTAINER_DEFINITION: 'CONTAINER_DEFINITION',
  WIDGET_DEFINITION: 'WIDGET_DEFINITION',
  MANAGE_WIDGET: 'MANAGE_WIDGET',
  BULK_STATE_CHANGE: 'BULK_STATE_CHANGE',
  REVOKE_ACCESS: 'REVOKE_ACCESS',
}
